/** semantic-tokens-ignore: Unclear if this should be changed */
import { cn } from '@tempo-io/sui-class-utils';
import type { RatioData } from '@/components/loop-dashboard/utils/ratioCalculations';
import { RATIO_DISPLAY_CAP } from '@/components/loop-dashboard/utils/ratioCalculations';
import { RatioBar } from './RatioBar';

export const VisualizationCell = ({
  ratioData,
  actualSeconds,
  planSeconds,
  isParentRow,
}: {
  ratioData: RatioData;
  actualSeconds: number;
  planSeconds: number;
  isParentRow: boolean;
}) => {
  return (
    <div className={cn('flex h-max w-full flex-col space-y-1', { 'font-bold': isParentRow })}>
      <RatioBar
        ratio={ratioData.actualRatio}
        seconds={actualSeconds}
        cap={RATIO_DISPLAY_CAP}
        backgroundColor="bg-purple-900"
        textColor="text-text-neutral-inverted"
      />

      <RatioBar
        ratio={ratioData.planRatio}
        seconds={planSeconds}
        cap={RATIO_DISPLAY_CAP}
        backgroundColor="bg-purple-400"
        textColor="text-text-neutral-primary"
      />
    </div>
  );
};
